module.exports = __webpack_public_path__ + "img/8445.bef07484.jpg";